class UpdateRequest extends HTMLElement {
  constructor() {
    super();
    this.isBot = false;
  }

  connectedCallback() {
    this.formStart = Date.now();

    const params = new URLSearchParams(window.location.search);
    const type = params.get("type");
    if (["email", "phone"].includes(type)) {
      this.querySelector("[data-type-form]").classList.remove("hidden");
      this.selectType(type);
    } else {
      this.querySelector("[data-type-chooser]").classList.remove("hidden");
    }

    const email = params.get("email");
    if (email) {
      this.querySelectorAll('[name="email"]').forEach(
        (el) => (el.value = email),
      );
    }

    this.initClickEvents();
    this.initInputEvents();
    this.initSubmitEvents();
  }

  selectType(value) {
    this.applyReveal(value);
  }

  applyReveal(value) {
    this.querySelectorAll("[data-reveal-group]").forEach((el) => {
      el.classList.toggle("hidden", el.dataset.revealGroup !== value);
    });
  }

  getActiveForm() {
    return this.querySelector("form[data-reveal-group]:not(.hidden)");
  }

  validateFields(form) {
    if (!form) return false;
    let hasNoErrors = true;

    form.querySelectorAll("[data-field]").forEach((field) => {
      const input = field.querySelector("input, textarea");
      const errorField = field.querySelector("[data-field-error]");
      if (!input || !errorField) return;

      if (input.name === "first_name") {
        if (!input.value.trim()) {
          errorField.innerText = window.contactStrings.name;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "last_name") {
        if (!input.value.trim()) {
          errorField.innerText = window.contactStrings.surname;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "email") {
        if (!input.value.trim()) {
          errorField.innerText = window.contactStrings.email_empty;
          hasNoErrors = false;
        } else if (!input.checkValidity()) {
          errorField.innerText = window.contactStrings.email;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "email-confirm") {
        if (!input.value.trim()) {
          errorField.innerText = window.contactStrings.email_validation_empty;
          hasNoErrors = false;
        } else if (
          input.value.trim() !==
          form.querySelector("[name='email']").value.trim()
        ) {
          errorField.innerText = window.contactStrings.email_validation;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "new_email") {
        // The `email` field in this form is the customer's current address.
        const currentEmail = form
          .querySelector('[name="email"]')
          .value.trim()
          .toLowerCase();

        if (!input.value.trim()) {
          errorField.innerText = window.updateRequestStrings.new_email_empty;
          hasNoErrors = false;
        } else if (!input.checkValidity()) {
          errorField.innerText = window.updateRequestStrings.new_email;
          hasNoErrors = false;
        } else if (input.value.trim().toLowerCase() === currentEmail) {
          errorField.innerText = window.updateRequestStrings.email_unchanged;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "new_email_confirm") {
        if (!input.value.trim()) {
          errorField.innerText =
            window.updateRequestStrings.new_email_confirm_empty;
          hasNoErrors = false;
        } else if (
          input.value.trim() !==
          form.querySelector("[name='new_email']").value.trim()
        ) {
          errorField.innerText = window.updateRequestStrings.new_email_confirm;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "current_phone") {
        if (!input.value.trim()) {
          errorField.innerText =
            window.updateRequestStrings.current_phone_empty;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "new_phone") {
        // ponytail: digits-only compare, so "090-1234-5678" and "09012345678" match.
        // "+819012345678" vs "09012345678" will not — this is a client-side UX guard,
        // the backend is the authority. Normalize country codes only if support asks.
        const digits = (value) => value.replace(/\D/g, "");
        const currentPhone = digits(
          form.querySelector('[name="current_phone"]').value,
        );

        if (!input.value.trim()) {
          errorField.innerText = window.updateRequestStrings.new_phone_empty;
          hasNoErrors = false;
        } else if (!input.checkValidity()) {
          errorField.innerText = window.updateRequestStrings.new_phone;
          hasNoErrors = false;
        } else if (currentPhone && digits(input.value) === currentPhone) {
          errorField.innerText = window.updateRequestStrings.phone_unchanged;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "new_phone_confirm") {
        if (!input.value.trim()) {
          errorField.innerText =
            window.updateRequestStrings.new_phone_confirm_empty;
          hasNoErrors = false;
        } else if (
          input.value.trim() !==
          form.querySelector("[name='new_phone']").value.trim()
        ) {
          errorField.innerText = window.updateRequestStrings.new_phone_confirm;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name && input.name.startsWith("security_answer_")) {
        if (!input.value.trim()) {
          errorField.innerText =
            window.updateRequestStrings.security_answer_empty;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "message") {
        if (input.value.length > 2000) {
          errorField.innerText = window.contactStrings.body_limit;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "consent") {
        if (!input.checked) {
          errorField.innerText = window.contactStrings.consent;
          hasNoErrors = false;
        } else {
          errorField.innerText = "";
        }
      } else if (input.name === "store") {
        if (input.value.trim()) {
          this.isBot = true;
        }
      }
    });

    return hasNoErrors;
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        switch (e.target.dataset.trigger) {
          case "close":
            e.target
              .closest(".update-request__success")
              .classList.remove("open");
            break;
        }
      }
    });
  }

  initInputEvents() {
    this.addEventListener("input", (e) => {
      const target = e.target;
      this.validateFields(this.getActiveForm());

      if (target.tagName === "TEXTAREA") {
        target.style.height = "auto";
        target.style.height = `${target.scrollHeight}px`;
      }
    });
  }

  initSubmitEvents() {
    this.querySelectorAll("form").forEach((form) => {
      form.addEventListener("submit", (e) =>
        this.handleSubmit(e, form.querySelector('button[type="submit"]')),
      );
    });
  }

  async handleSubmit(e, submitButton) {
    e.preventDefault();

    const form = e.target.closest("form");
    const formError = form.querySelector(".form-error");
    formError.classList.remove("form-error--active");

    if (!this.validateFields(form)) {
      const errored = [...form.querySelectorAll("[data-field]")].find((field) =>
        field.querySelector("[data-field-error]")?.innerText.trim(),
      );
      const input = errored?.querySelector("input, textarea");
      if (input) {
        input.scrollIntoView({ behavior: "smooth", block: "center" });
        input.focus({ preventScroll: true });
      }
      return;
    }

    const timeSpent = (Date.now() - this.formStart) / 1000;
    if (timeSpent < 3) {
      submitButton.setAttribute("disabled", true);
      submitButton.classList.add("update-request__button--loading");

      setTimeout(() => {
        submitButton.removeAttribute("disabled");
        submitButton.classList.remove("update-request__button--loading");
        this.formStart = Date.now();
      }, 2000);
      return;
    }

    if (this.isBot) {
      form.reset();
      form.querySelector(".update-request__success").classList.add("open");
      this.isBot = false;
      return;
    }

    const formData = new FormData(form);
    const dataJson = Object.fromEntries(formData.entries());

    const basePayload = {
      first_name: dataJson.first_name,
      last_name: dataJson.last_name,
      locale: window.language,
      message: dataJson.message || "",
      hCaptcha: dataJson["h-captcha-response"] || null,
    };

    const data =
      dataJson.request_type === "phone"
        ? {
            ...basePayload,
            email: dataJson.email,
            current_phone: dataJson.current_phone,
            new_phone: dataJson.new_phone,
            new_phone_confirm: dataJson.new_phone_confirm,
          }
        : {
            ...basePayload,
            email: dataJson.email,
            security_answers: [1, 2, 3].map((i) => ({
              question: form
                .querySelector(`[name="security_answer_${i}"]`)
                .closest("[data-field]").dataset.questionLabel,
              answer: dataJson[`security_answer_${i}`],
            })),
            new_email: dataJson.new_email,
          };
    submitButton.setAttribute("disabled", true);
    submitButton.classList.add("update-request__button--loading");

    try {
      const response = await fetch(
        `${window.apiURL}/update-request/${dataJson.request_type}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );
      const responseData = await response.json();

      if (responseData.message == "email_sent") {
        form.querySelector(".update-request__success").classList.add("open");
        form.reset();
        this.selectType(dataJson.request_type);
      } else if (responseData.message == "invalid_captcha") {
        formError.classList.add("form-error--active");
        formError.innerText = errorMessages?.form?.invalid_captcha;
        submitButton.removeAttribute("disabled");
      } else {
        formError.classList.add("form-error--active");
        formError.innerText = errorMessages?.request?.bad;
        submitButton.removeAttribute("disabled");
      }
    } catch (error) {
      formError.classList.add("form-error--active");
      formError.innerText = errorMessages?.request?.bad;
      submitButton.removeAttribute("disabled");
      console.error(error);
    } finally {
      submitButton.classList.remove("update-request__button--loading");
    }
  }
}

customElements.define("update-request", UpdateRequest);
